import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../App";

const AuthPage = () => {
  const { user, loginWithGoogle, loginWithEmail, registerWithEmail } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) {
      const redirectTo = location.state?.from?.pathname || "/";
      navigate(redirectTo, { replace: true });
    }
  }, [user, location.state, navigate]);

  const onChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      if (mode === "login") {
        await loginWithEmail(form.email, form.password);
      } else {
        await registerWithEmail(form.name, form.email, form.password);
      }
      const redirectTo = location.state?.from?.pathname || "/";
      navigate(redirectTo, { replace: true });
    } catch (err) {
      const message = err?.response?.data?.detail || "Operazione non riuscita";
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4" data-testid="auth-page">
      <div className="w-full max-w-xl border-4 border-black p-8 shadow-brutal-lg bg-white">
        <div className="flex items-center justify-between mb-6">
          <h1 className="font-heading text-4xl">{mode === "login" ? "Accedi" : "Registrati"}</h1>
          <div className="flex gap-2">
            <button
              onClick={() => setMode("login")}
              className={`px-4 py-2 border-2 border-black font-body font-semibold ${
                mode === "login" ? "bg-black text-white" : "bg-white"
              }`}
            >
              Login
            </button>
            <button
              onClick={() => setMode("register")}
              className={`px-4 py-2 border-2 border-black font-body font-semibold ${
                mode === "register" ? "bg-black text-white" : "bg-white"
              }`}
            >
              Registrati
            </button>
          </div>
        </div>

        <div className="mb-6">
          <button
            onClick={loginWithGoogle}
            className="w-full btn-brutal"
            type="button"
            data-testid="google-login"
          >
            Continua con Google
          </button>
        </div>

        <div className="border-t-2 border-black pt-6">
          <form onSubmit={submit} className="space-y-4">
            {mode === "register" && (
              <div>
                <label className="block font-body font-semibold mb-2">Nome</label>
                <input
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={onChange}
                  className="w-full border-2 border-black p-3 font-body"
                  required
                />
              </div>
            )}
            <div>
              <label className="block font-body font-semibold mb-2">Email</label>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={onChange}
                className="w-full border-2 border-black p-3 font-body"
                required
              />
            </div>
            <div>
              <label className="block font-body font-semibold mb-2">Password</label>
              <input
                type="password"
                name="password"
                value={form.password}
                onChange={onChange}
                className="w-full border-2 border-black p-3 font-body"
                minLength={6}
                required
              />
            </div>

            {error && (
              <div className="border-2 border-black bg-accent-yellow p-3 font-mono text-sm">
                {error}
              </div>
            )}

            <button
              className="btn-brutal w-full"
              type="submit"
              disabled={loading}
              data-testid="auth-submit"
            >
              {loading ? "Attendi..." : mode === "login" ? "Accedi" : "Crea account"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AuthPage;
